/** Browser-side storey-link persistence.
 *
 * IfcModel#transform is JSONB but the API permit-list and `transform_hash`
 * keep only x/y/z/rotX/rotY/rotZ as floats. There is no settings/metadata
 * column, and we must not edit the dirty admin-ops API branch. Maps live
 * here so the next session on this browser still remembers.
 */

const keyFor = (projectId) => `promang.ifc.storeyMap.${projectId}`;

export function readStoreyMaps(projectId) {
  if (!projectId || typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(keyFor(projectId));
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (_) {
    return {};
  }
}

export function readStoreyMap(projectId, modelId) {
  const all = readStoreyMaps(projectId);
  return all[String(modelId)] || null;
}

export function writeStoreyMap(projectId, modelId, payload) {
  if (!projectId || !modelId || typeof window === "undefined") return;
  const all = readStoreyMaps(projectId);
  all[String(modelId)] = {
    links: Array.isArray(payload?.links) ? payload.links : [],
    datumModelId: payload?.datumModelId || null,
    confirmed: Boolean(payload?.confirmed),
  };
  try {
    window.localStorage.setItem(keyFor(projectId), JSON.stringify(all));
  } catch (_) {
    /* quota / private mode — session still has the live map */
  }
}

/** Replace creates a new IfcModel id — copy the browser map onto it. */
export function copyStoreyMap(projectId, fromId, toId) {
  if (!projectId || !fromId || !toId) return false;
  if (String(fromId) === String(toId)) return false;
  const payload = readStoreyMap(projectId, fromId);
  if (!payload?.links?.length) return false;
  writeStoreyMap(projectId, toId, payload);
  return true;
}
